import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useRouter } from 'next/router';

import { searchMessages } from '@/core/messages/search.messages';
import { MarginWrapper } from '@/core/components/MarginWrapper';
import { Loader } from '@/core/components/Loader';

import { Pagination } from '@/utils/request.types';

import {
  Content,
  EmptyResults,
  Footer,
  FormWrapper,
  ListWrapper,
  Text,
  Title,
  TitleWrapper,
  Wrapper,
} from './Search.styles';
import { SearchForm } from './SearchForm';
import { api } from './api';
import { SearchData } from './Search.types';
import { SearchResults } from './SearchResults';

export const Search = () => {
  const { locale } = useRouter();

  const [
    results,
    setResults,
  ] = useState<SearchData>([]);

  const [
    pagination,
    setPagination,
  ] = useState<Pagination>({
    page: 1,
    pageCount: 0,
    pageSize: 20,
    total: 0,
  });

  const [
    isLoading,
    setIsLoading,
  ] = useState(false);

  const [
    currentSearchPhrase,
    setCursentSearchPhrase,
  ] = useState('');

  const handleSearch = async (searchPhrase: string) => {
    setIsLoading(true);
    setCursentSearchPhrase(searchPhrase);

    try {
      const { data } = await api.getSearchResults({
        locale,
        'pagination[pageSize]': pagination.pageSize,
        search: searchPhrase,
      });

      setPagination(data.meta.pagination as Pagination);
      setResults(data.data);
    } finally {
      setIsLoading(false);
    }
  };

  const handleShowMore = async () => {
    setIsLoading(true);

    try {
      const { data: resData } = await api.getSearchResults({
        locale,
        'pagination[page]': pagination.page + 1,
        'pagination[pageSize]': pagination.pageSize,
        search: currentSearchPhrase,
      });

      setResults([
        ...results,
        ...resData.data,
      ]);
      setPagination(resData.meta.pagination as Pagination);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Wrapper>
      <Content>
        <MarginWrapper>
          <FormWrapper>
            <TitleWrapper>
              <Title>
                <FormattedMessage {...searchMessages.headingSearch} />
              </Title>
              <Text>
                <FormattedMessage {...searchMessages.subheadingSearch} />
              </Text>
            </TitleWrapper>
            <SearchForm handleSearch={handleSearch} />
          </FormWrapper>
          <ListWrapper>
            {!!pagination.total && (
              <SearchResults
                data={results}
                pagination={pagination}
                isLoading={isLoading}
                onShowMore={handleShowMore}
              />
            )}
            {isLoading && <Loader />}
            {currentSearchPhrase && !isLoading && !pagination.total && (
              <EmptyResults>
                <FormattedMessage {...searchMessages.empty} />
              </EmptyResults>
            )}
          </ListWrapper>
        </MarginWrapper>
      </Content>
      <Footer />
    </Wrapper>
  );
};
